import config from '../../config'
// deprecated
export function etherscanUrl (type, string) {
  if (!string) return ''

  const network = config.NETWORK

  if (!network || network === 'mainnet') {
    return `https://etherscan.io/${type}/${string}`
  }
  return `https://${network}.etherscan.io/${type}/${string}`
}
// deprecated
export function polygonscanUrl (type, string) {
  if (!string) return ''

  const network = config.POLYGON_NETWORK

  if (!network || network === 'mainnet') {
    return `https://polygonscan.com/${type}/${string}`
  }
  return `https://${network}.polygonscan.com/${type}/${string}`
}

export function explorerUrl (type, string, url) {
  if (!string) return ''

  return `${url}/${type}/${string}`
}

export function imageUrlToSumsubDocs (inspectionId, imageId) {
  if (/\/$/.test(config.API_URL)) {
    return `${config.API_URL}sumsub/docs/${inspectionId}/${imageId}`
  }
  return `${config.API_URL}/sumsub/docs/${inspectionId}/${imageId}`
}

export function getTokenIcon () {
  // https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons/svg/color/${token.toLowerCase}.svg
}
